import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { SystemService } from 'app/Services/system.service';

@Component({
  selector: 'np-golden-record-catalog-details',
  templateUrl: './golden-record-catalog-details.component.html',
  standalone: false,
  styleUrls: ['./golden-record-catalog-details.component.css']
})
export class GoldenRecordCatalogDetailsComponent implements OnInit {

  public catalogTitle = '';
  public customerIdFromRoute: string | null = null;
  public catalogIdFromRoute: string | null = null;

  public constructor(
    private activatedRoute: ActivatedRoute,
    public systemService: SystemService,
    private catalogService: CatalogService,
    public translate: TranslateService,
    private router: Router
  ) {}

  public ngOnInit(): void {
    this.customerIdFromRoute = this.activatedRoute.snapshot.paramMap.get('customerId');
    this.catalogIdFromRoute = this.activatedRoute.snapshot.paramMap.get('catalogId');

    if (!this.customerIdFromRoute || !this.catalogIdFromRoute) {
      this.systemService.notifyWarning(
        this.translate.instant('Route Parameter customerId oder catalogId fehlen.')
      );
      this.router.navigate(['/dataprocess/golden-record']);
      return;
    }

    this.catalogService.browseRoutePrefix = '/dataprocess/golden-record/catalog';

    this.systemService.currentNavigationTitle = 'Golden Record';

    this.catalogService
      .getCatalog(this.catalogIdFromRoute, this.customerIdFromRoute)
      .subscribe((catalog: any) => {
        this.catalogTitle = this.getCatalogTitleFromCatalog(catalog, this.catalogIdFromRoute!);
      });
  }

  public goBack(): void {
    this.router.navigate(['/dataprocess/golden-record']);
  }

  private getCatalogTitleFromCatalog(catalog: any, fallbackCatalogId: string): string {
    const title =
      catalog?.descriptionShort ??
      catalog?.catalogName ??
      catalog?.name ??
      catalog?.groupName ??
      catalog?.title;

    return title && String(title).trim().length > 0 ? String(title) : fallbackCatalogId;
  }
}
